declare let mxGeometryChange: any; // available globally
import * as _ from 'lodash';

export function conTermGraphChange(graph, cell, change, isConnector) {
  if (!(change instanceof mxGeometryChange)) {
    return null;
  }

  const geometry = cell.geometry;
  const action: any = {};
  const edge: any = cell.edges[0];

  action.flowlineMxKey = Number(edge.id);
  action.position = {
    x: geometry.x,
    y: geometry.y,
    w: geometry.width,
    h: geometry.height
  };

  return {
    data: _.cloneDeep(action),
    action: isConnector ? 'changeConnector' : 'changeTerminator',
    type: isConnector ? 'connector' : 'terminator',
    mxKey: +cell.id
  };
}
